import styled from '@emotion/styled'
import { ApiMutualFundAssetRead, ApiSegregatedPortfolioAssetRead } from 'api/rtk-api'
import { useEffect, useState } from 'react'

import { OperationButton, Space, Typography, ValidationMessage } from '../../../components/core-v2'
import { StateCircle } from '../../../components/core-v2/atoms/circle/StateCircle'
import CalendarEvents from '../../../components/core-v2/organisms/calendar-events'
import { Errors } from '../../tradebuilder-v2/util'

export type ExDatesProps = {
  errors: Errors
  onSaveExDates: (selectedDates: Date[]) => void
  selectedAsset: ApiMutualFundAssetRead | ApiSegregatedPortfolioAssetRead
}

const StyledExDatesPanel = styled(Space)`
  height: calc(100vh - 320px);
  overflow-y: auto;
`

const StyledControlPanel = styled(Space)`
  max-width: 760px;
`

export const ExDatesTab = ({ errors, onSaveExDates, selectedAsset }: ExDatesProps) => {
  const [userDates, setUserDates] = useState<Date[]>([])

  useEffect(() => {
    const userExDates =
      selectedAsset.exDates
        .filter(item => item.provider === 'Absa')
        .map(item => new Date(item.date)) ?? []
    setUserDates(userExDates)
  }, [selectedAsset])

  const finSwitchDates =
    selectedAsset.exDates
      .filter(item => item.provider === 'FinSwitch')
      .map(item => new Date(item.date)) ?? []

  const onUserDatesChange = (selectedDates: Date[]) => {
    setUserDates(selectedDates)
  }
  const onSaveDates = () => {
    onSaveExDates(userDates)
  }
  return (
    <Space>
      <StyledExDatesPanel>
        <CalendarEvents
          finSwitchDates={finSwitchDates}
          userDates={userDates}
          onUserDatesChange={onUserDatesChange}
        />
      </StyledExDatesPanel>
      <Space>
        <ValidationMessage errors={errors} />
      </Space>
      <StyledControlPanel isflex flexDirection="row" justifyContent="space-between" my={5}>
        <Space isflex flexDirection="row" py={2}>
          <Space mx={2}>
            <Typography variant="b4">
              <StateCircle state="disabled" />
              User selected
            </Typography>
          </Space>
          <Space mx={2}>
            <Typography variant="b4">
              <StateCircle state="success" />
              Finswitch selected
            </Typography>
          </Space>
        </Space>
        <OperationButton operationType="progress" onClick={onSaveDates}>
          Save
        </OperationButton>
      </StyledControlPanel>
    </Space>
  )
}
